module.exports = __webpack_public_path__ + "static/media/CheckIcon.6af0da93.svg";